module.exports = __webpack_public_path__ + "img/2025-05-09b_1.34c7838d.jpg";